<template>
  <b-modal 
    ref="modalNotaFiscal" 
    id="modal-configuracao-notafiscal" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="xl"
    @shown="onModalShown"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #673ab7 0%, #512da8 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-file-text text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Configurações de Nota Fiscal</h5>
        <small class="text-white opacity-75">Defina os parâmetros de emissão e armazenamento de NFe</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Corpo do Modal -->
    <div class="p-4" style="max-height: 70vh; overflow-y: auto;">
      
      <!-- Grupo Dados da Empresa - DANFE -->
      <div class="modal-section-title mb-3">
        <i class="fa fa-building mr-2 text-primary"></i> Dados da Empresa - DANFE
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Nome Resumido para Relatório" label-for="tx-nome-rezumido">
            <b-form-input
              v-model="registro.TX_NOME_REZUMIDO"
              maxlength="100"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Nome Resumido 2" label-for="tx-rezumido2">
            <b-form-input
              v-model="registro.TX_REZUMIDO2"
              maxlength="100"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Nome/Razão Social" label-for="tx-razao-social">
            <b-form-input
              v-model="registro.TX_RAZAO_SOCIAL"
              maxlength="255"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Endereços dos Arquivos -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-folder-open mr-2 text-warning"></i> Endereços dos Arquivos
      </div>
      <b-row>
        <b-col md="12">
          <b-form-group label="XML das NFE" label-for="tx-path-nfe-xml">
            <b-form-input
              v-model="registro.TX_PATH_NFE_XML"
              maxlength="255"
              placeholder="C:\NFe\XML"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="XML dos Lotes" label-for="tx-path-nfe-lote-xml">
            <b-form-input
              v-model="registro.TX_PATH_NFE_LOTE_XML"
              maxlength="255"
              placeholder="C:\NFe\Lotes"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="XML do Retorno" label-for="tx-path-nfe-erros">
            <b-form-input
              v-model="registro.TX_PATH_NFE_ERROS"
              maxlength="255"
              placeholder="C:\NFe\Erros"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Transportadora -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-truck mr-2 text-success"></i> Transportadora
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Transportadora Preferencial" label-for="id-transp-nf">
            <transportadora-drop-down 
              v-model="registro.ID_TRANSP_NF"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo WebService -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-cloud mr-2 text-info"></i> WebService
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Ambiente" label-for="op-nfe-ambiente">
            <b-form-select v-model="registro.OP_NFE_AMBIENTE">
              <option value="1">1 - Produção</option>
              <option value="2">2 - Homologação</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Tipo de Emissão" label-for="op-tipo-emissao-nfe">
            <b-form-select v-model="registro.OP_TIPO_EMISSAO_NFE">
              <option value="0">0 - Normal</option>
              <option value="1">1 - SVC - Contingência</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Gerais -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-cogs mr-2 text-danger"></i> Gerais
      </div>

      <b-row>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_ATUALIZAR_XML"
            value="1"
            unchecked-value="0"
          >
            Atualizar XML
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_RETIRAR_ACENTOS"
            value="1"
            unchecked-value="0"
          >
            Retirar Acentos dos XMLs enviados
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_CRIAR_PASTA_MES"
            value="1"
            unchecked-value="0"
          >
            Criar Pastas Mensalmente
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_ADICIONAR_LITERAL"
            value="1"
            unchecked-value="0"
          >
            Adicionar Literal no nome das pastas
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_SALVAR_DOC_EMISSAO"
            value="1"
            unchecked-value="0"
          >
            Salvar Documento pelo campo Data de Emissão
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_SEPARAR_CNPJ"
            value="1"
            unchecked-value="0"
          >
            Separar Arquivos pelo CNPJ do Certificado
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_SALVAR_ENVIO_RESP"
            value="1"
            unchecked-value="0"
          >
            Salvar Arquivos de Envio e Resposta
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_NFE_SALVAR_ARQ_EVENTO"
            value="1"
            unchecked-value="0"
          >
            Salvar Arquivos de Eventos
          </b-form-checkbox>
        </b-col>
      </b-row>

    </div>

    <!-- Rodapé Premium -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
        <i class="fa fa-check-circle mr-1"></i> SALVAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import TransportadoraDropDown from '../views/componentes/dropdown/TransportadoraDropDown.vue'

export default {
  name: 'ModalConfiguracaoNotaFiscal',
  components: {
    TransportadoraDropDown
  },
  data() {
    return {
      registro: {
        SEQUENCIA: 1,
        // Dados da Empresa - DANFE
        TX_NOME_REZUMIDO: '',
        TX_REZUMIDO2: '',
        TX_RAZAO_SOCIAL: '',
        // Endereços dos Arquivos
        TX_PATH_NFE_XML: '',
        TX_PATH_NFE_LOTE_XML: '',
        TX_PATH_NFE_ERROS: '',
        // Transportadora
        ID_TRANSP_NF: null,
        // WebService
        OP_NFE_AMBIENTE: '1',
        OP_TIPO_EMISSAO_NFE: '0',
        // Gerais
        OP_NFE_ATUALIZAR_XML: '0',
        OP_NFE_RETIRAR_ACENTOS: '0',
        OP_NFE_CRIAR_PASTA_MES: '0',
        OP_NFE_ADICIONAR_LITERAL: '0',
        OP_NFE_SALVAR_DOC_EMISSAO: '0',
        OP_NFE_SEPARAR_CNPJ: '0',
        OP_NFE_SALVAR_ENVIO_RESP: '0',
        OP_NFE_SALVAR_ARQ_EVENTO: '0'
      }
    }
  },
  methods: {
    abrir() {
      this.$refs.modalNotaFiscal.show()
    },
    fechar() {
      this.$refs.modalNotaFiscal.hide()
    },
    async carregarDados() {
      try {
        const { data } = await this.$http.get('/api/protected/parametro/getDados')
        if (data && data.length > 0) {
          this.registro = {
            ...this.registro,
            ...data[0],
            // Garantir valores default para campos de texto
            TX_NOME_REZUMIDO: data[0].TX_NOME_REZUMIDO || '',
            TX_REZUMIDO2: data[0].TX_REZUMIDO2 || '',
            TX_RAZAO_SOCIAL: data[0].TX_RAZAO_SOCIAL || '',
            TX_PATH_NFE_XML: data[0].TX_PATH_NFE_XML || '',
            TX_PATH_NFE_LOTE_XML: data[0].TX_PATH_NFE_LOTE_XML || '',
            TX_PATH_NFE_ERROS: data[0].TX_PATH_NFE_ERROS || '',
            // Garantir valores default para selects
            OP_NFE_AMBIENTE: data[0].OP_NFE_AMBIENTE || '1',
            OP_TIPO_EMISSAO_NFE: data[0].OP_TIPO_EMISSAO_NFE || '0',
            // Garantir valores default para checkboxes
            OP_NFE_ATUALIZAR_XML: data[0].OP_NFE_ATUALIZAR_XML || '0',
            OP_NFE_RETIRAR_ACENTOS: data[0].OP_NFE_RETIRAR_ACENTOS || '0',
            OP_NFE_CRIAR_PASTA_MES: data[0].OP_NFE_CRIAR_PASTA_MES || '0',
            OP_NFE_ADICIONAR_LITERAL: data[0].OP_NFE_ADICIONAR_LITERAL || '0',
            OP_NFE_SALVAR_DOC_EMISSAO: data[0].OP_NFE_SALVAR_DOC_EMISSAO || '0',
            OP_NFE_SEPARAR_CNPJ: data[0].OP_NFE_SEPARAR_CNPJ || '0',
            OP_NFE_SALVAR_ENVIO_RESP: data[0].OP_NFE_SALVAR_ENVIO_RESP || '0',
            OP_NFE_SALVAR_ARQ_EVENTO: data[0].OP_NFE_SALVAR_ARQ_EVENTO || '0'
          }
        }
      } catch (err) {
        console.error('Erro ao carregar configurações:', err)
        this.$root.$bvToast.toast('Erro ao carregar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    async salvar() {
      try {
        const { data } = await this.$http.post('/api/protected/parametro/update', {
          registro: this.registro
        })
        
        this.$root.$bvToast.toast(data.mensagem || 'Configurações salvas com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })
        
        this.fechar()
      } catch (err) {
        console.error('Erro ao salvar configurações:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    onModalShown() {
      this.carregarDados()
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/modals/ModalConfiguracaoNotaFiscal.vue